<!-- eslint-disable -->
<template lang="pug">
    div(:is="continent")
</template>

<script>
    /*eslint-disable*/
    import Eurasia from './continents/Eurasia.vue'
    import Africa from './continents/Africa.vue'
    import Australia from './continents/Australia.vue'
    import Antarctica from './continents/Antarctica.vue'
    import SouthAmerica from './continents/SouthAmerica.vue'
    import NorthAmerica from './continents/NorthAmerica.vue'
    import Space from "./continents/Space.vue";

    export default {
        props: {
            continent: String
        },
        components: {
            Eurasia,
            Africa,
            Antarctica,
            Australia,
            SouthAmerica,
            NorthAmerica,
            Space
        }
    }
</script>

<style>
    .cls-48 {
        fill: #fff
    }

    .cls-1398, .cls-2140, .cls-2515, .cls-2578, .cls-3061, .cls-3173, .cls-3317, .cls-347, .cls-4122 {
        stroke-miterlimit: 10
    }

    .cls-37 {
        fill: #edaa1f
    }

    .cls-49 {
        fill: #fbe9d0
    }

    .cls-50 {
        fill: #a68c6b
    }

    .cls-53 {
        fill: #855823
    }

    .cls-54 {
        fill: #ac9270
    }

    .cls-61 {
        fill: #c79054
    }

    .cls-75 {
        fill: #737571
    }

    .cls-76 {
        fill: #5c5e5a
    }

    .cls-96 {
        fill: #a6b8de
    }

    .cls-108 {
        fill: #aabbe0
    }

    .cls-109 {
        fill: #827767
    }

    .cls-193 {
        fill: #ffd758
    }

    .cls-194 {
        fill: #fdbe13
    }

    .cls-195 {
        fill: #75963d
    }

    .cls-197 {
        fill: #c9da30
    }

    .cls-199 {
        fill: #f89a2c
    }

    .cls-201 {
        fill: #d66327
    }

    .cls-204 {
        fill: #d66427
    }

    .cls-206 {
        fill: #f7be35
    }

    .cls-207 {
        fill: #85d0d4
    }

    .cls-208 {
        fill: #b75927
    }

    .cls-209 {
        fill: #d76527
    }

    .cls-217 {
        fill: #609700
    }

    .cls-218 {
        fill: #9de118
    }

    .cls-219 {
        fill: #7fd000
    }

    .cls-220 {
        fill: #af6633
    }

    .cls-221 {
        fill: #e48749
    }

    .cls-228 {
        fill: #8b4631
    }

    .cls-232 {
        fill: #008538
    }

    .cls-233 {
        fill: #006628
    }

    .cls-234 {
        fill: #00b14f
    }

    .cls-235 {
        fill: #00b050
    }

    .cls-236 {
        fill: #552617
    }

    .cls-245 {
        fill: #88532a
    }

    .cls-246 {
        fill: #a96531
    }

    .cls-251 {
        fill: #ffd5aa
    }

    .cls-252 {
        fill: #ffc78a
    }

    .cls-254 {
        fill: #c77b38
    }

    .cls-255 {
        fill: #ffd6aa
    }

    .cls-256 {
        fill: #ffc88a
    }

    .cls-259 {
        fill: #693e1d
    }

    .cls-261 {
        fill: #fdfcfb
    }

    .cls-262 {
        fill: #301906
    }

    .cls-264 {
        fill: #c2681c
    }

    .cls-266 {
        fill: #bc6d29
    }

    .cls-267 {
        fill: #ffdfbc
    }

    .cls-269 {
        fill: #eb8f43
    }

    .cls-270 {
        fill: #1f1a1b
    }

    .cls-271 {
        fill: #ffdfb9
    }

    .cls-272 {
        fill: #ee9248
    }

    .cls-273 {
        fill: #ec9247
    }

    .cls-274 {
        fill: #ffdfbb
    }

    .cls-276 {
        fill: #ee9952
    }

    .cls-279 {
        fill: #c67b38
    }

    .cls-285 {
        fill: #d4cccc
    }

    .cls-293 {
        fill: #ffca8c
    }

    .cls-298 {
        fill: #9b5418
    }

    .cls-299 {
        fill: #9c5418
    }

    .cls-347 {
        fill: #235652
    }

    .cls-1398, .cls-2140, .cls-2515, .cls-2578, .cls-3061, .cls-3173, .cls-3317, .cls-347, .cls-4122 {
        stroke: #fff
    }

    .cls-2140, .cls-3317, .cls-347 {
        stroke-width: .25px
    }

    .cls-348 {
        fill: #d73127
    }

    .cls-349 {
        fill: #ee3e28
    }

    .cls-352 {
        fill: red
    }

    .cls-356 {
        fill: #ffe1bd
    }

    .cls-359 {
        fill: #c4681c
    }

    .cls-374 {
        fill: #eb8f45
    }

    .cls-377 {
        fill: #c67a38
    }

    .cls-394 {
        fill: #606a62
    }

    .cls-395 {
        fill: #ffc789
    }

    .cls-398 {
        fill: #ffd5ad
    }

    .cls-460 {
        fill: #c97a39
    }

    .cls-463 {
        fill: #bd6c28
    }

    .cls-464 {
        fill: #1d1a1b
    }

    .cls-465 {
        fill: #ffe3be
    }

    .cls-470 {
        fill: #e98e43
    }

    .cls-471 {
        fill: #ffd6ab
    }

    .cls-472 {
        fill: #c67a3b
    }

    .cls-473 {
        fill: #eb8e43
    }

    .cls-475 {
        fill: #392311
    }

    .cls-476 {
        fill: #c3671b
    }

    .cls-477 {
        fill: #ffdfba
    }

    .cls-478 {
        fill: #fffffd
    }

    .cls-480 {
        fill: #c4681b
    }

    .cls-498 {
        fill: #ffd6a9
    }

    .cls-506 {
        fill: #fdfdfd
    }

    .cls-513 {
        fill: #4e2706
    }

    .cls-519 {
        fill: #9e541a
    }

    .cls-521 {
        fill: #683c19
    }

    .cls-522 {
        fill: #503521
    }

    .cls-523 {
        fill: #90592d
    }

    .cls-525 {
        fill: #e59457
    }

    .cls-526 {
        fill: #e69457
    }

    .cls-569 {
        fill: #ff7800
    }

    .cls-573 {
        fill: #e98000
    }

    .cls-575 {
        fill: #c77a39
    }

    .cls-576 {
        fill: #c36a1d
    }

    .cls-577 {
        fill: #ffd4ab
    }

    .cls-578 {
        fill: #ffc889
    }

    .cls-581 {
        fill: #c87b37
    }

    .cls-582 {
        fill: #c26919
    }

    .cls-583 {
        fill: #c1681b
    }

    .cls-584 {
        fill: #fffdfc
    }

    .cls-585 {
        fill: #fdfdfc
    }

    .cls-586 {
        fill: #fdfcfc
    }

    .cls-587 {
        fill: #ec9047
    }

    .cls-588 {
        fill: #c16818
    }

    .cls-589 {
        fill: #ffdeb8
    }

    .cls-590 {
        fill: #c3671e
    }

    .cls-593 {
        fill: #6e8f17
    }

    .cls-603 {
        fill: #ffd4a9
    }

    .cls-604 {
        fill: #c27c38
    }

    .cls-605 {
        fill: #ffd19f
    }

    .cls-606 {
        fill: #aa5c00
    }

    .cls-609 {
        fill: #ffac45
    }

    .cls-615 {
        fill: #ffd0a3
    }

    .cls-616 {
        fill: #c87938
    }

    .cls-620 {
        fill: #4c3422
    }

    .cls-621 {
        fill: #4d3322
    }

    .cls-622 {
        fill: #384d09
    }

    .cls-623 {
        fill: #c8783a
    }

    .cls-624 {
        fill: #e59455
    }

    .cls-648 {
        fill: #fce16f
    }

    .cls-649 {
        fill: #110d0a
    }

    .cls-654 {
        fill: #674b2e
    }

    .cls-655 {
        fill: #4b3424
    }

    .cls-656 {
        fill: #2a1b10
    }

    .cls-657 {
        fill: #755638
    }

    .cls-658 {
        fill: #3f2c19
    }

    .cls-659 {
        fill: #412e1a
    }

    .cls-660 {
        fill: #2f2d30
    }

    .cls-661 {
        fill: #f3f3f3
    }

    .cls-662 {
        fill: #775a3d
    }

    .cls-663 {
        fill: #4e371e
    }

    .cls-669 {
        fill: #806e1a
    }

    .cls-674 {
        fill: #76593c
    }

    .cls-734 {
        fill: #c2661a
    }

    .cls-738 {
        fill: #e98e45
    }

    .cls-741 {
        fill: #ea8e41
    }

    .cls-742 {
        fill: #272426
    }

    .cls-743 {
        fill: #ea8d40
    }

    .cls-744 {
        fill: #f3a05e
    }

    .cls-745 {
        fill: #ed9248
    }

    .cls-746 {
        fill: #ffd7ab
    }

    .cls-747 {
        fill: #c57836
    }

    .cls-748 {
        fill: #c1671b
    }

    .cls-749 {
        fill: #ffd7ac
    }

    .cls-765 {
        fill: #c67c39
    }

    .cls-1076 {
        fill: #ffe0bc
    }

    .cls-1113 {
        fill: #ff877f
    }

    .cls-1115 {
        fill: #ff857b
    }

    .cls-1116 {
        fill: #ff867c
    }

    .cls-1117 {
        fill: #ff5c50
    }

    .cls-1131 {
        fill: #ff877c
    }

    .cls-1132 {
        fill: #ff877e
    }

    .cls-1134 {
        fill: #ffb5b3
    }

    .cls-1135 {
        fill: #ff8a81
    }

    .cls-1138 {
        fill: #ff887f
    }

    .cls-1146 {
        fill: #ffc659
    }

    .cls-1147 {
        fill: #ffb4b2
    }

    .cls-1152 {
        fill: #ffc657
    }

    .cls-1156 {
        fill: #ffc65a
    }

    .cls-1158 {
        fill: #ffc558
    }

    .cls-1165 {
        fill: #ffa600
    }

    .cls-1177 {
        fill: #ffb2af
    }

    .cls-1184 {
        fill: #ffc75b
    }

    .cls-1190 {
        fill: #ffb2b0
    }

    .cls-1199 {
        fill: #ffb7b5
    }

    .cls-1212 {
        fill: #00ebf3
    }

    .cls-1334 {
        fill: #d49200
    }

    .cls-1341 {
        fill: #d19000
    }

    .cls-1349 {
        fill: #d39200
    }

    .cls-1356 {
        fill: #d59300
    }

    .cls-1364 {
        fill: #c68900
    }

    .cls-1374 {
        fill: #ad6828
    }

    .cls-1377 {
        fill: #f5863c
    }

    .cls-1386 {
        fill: #a54e25
    }

    .cls-1389 {
        fill: #87b03f
    }

    .cls-1390 {
        fill: #75973e
    }

    .cls-1391 {
        fill: #afd140
    }

    .cls-1392 {
        fill: #835023
    }

    .cls-1393 {
        fill: #ae692d
    }

    .cls-1394 {
        fill: #d07c37
    }

    .cls-1395 {
        fill: #2e7e3f
    }

    .cls-1396 {
        fill: #72c179
    }

    .cls-1397 {
        fill: #4db75f
    }

    .cls-1398, .cls-2140 {
        fill: #13594b
    }

    .cls-1398, .cls-2515, .cls-2578, .cls-3061, .cls-3173, .cls-4122 {
        stroke-width: .5px
    }

    .cls-1409 {
        fill: #f26c21
    }

    .cls-1414 {
        fill: #774b1e
    }

    .cls-1415 {
        fill: #986126
    }

    .cls-1419 {
        fill: #483729
    }

    .cls-1420 {
        fill: #2b2117
    }

    .cls-1421 {
        fill: #65523d
    }

    .cls-1424 {
        fill: #58402d
    }

    .cls-1426 {
        fill: #323133
    }

    .cls-1439 {
        fill: #ba2025
    }

    .cls-1455 {
        fill: #d13227
    }

    .cls-1475 {
        fill: #a78254
    }

    .cls-1497 {
        fill: #f5981e
    }

    .cls-1500 {
        fill: #f6d5aa
    }

    .cls-1501 {
        fill: #f4c68b
    }

    .cls-1502 {
        fill: #f4c68a
    }

    .cls-1503 {
        fill: #f3d3ac
    }

    .cls-1504 {
        fill: #b6793f
    }

    .cls-1506 {
        fill: #a96d30
    }

    .cls-1507 {
        fill: #b57a3d
    }

    .cls-1508 {
        fill: #d58d49
    }

    .cls-1509 {
        fill: #f6c98f
    }

    .cls-1510 {
        fill: #222021
    }

    .cls-1511 {
        fill: #ae6a28
    }

    .cls-1512 {
        fill: #f6d5ab
    }

    .cls-1514 {
        fill: #ac6928
    }

    .cls-1515 {
        fill: #b27940
    }

    .cls-1516 {
        fill: #2f1f10
    }

    .cls-1517 {
        fill: #d5914c
    }

    .cls-1518 {
        fill: #faddbc
    }

    .cls-1519 {
        fill: #ad6829
    }

    .cls-1520 {
        fill: #d68f4c
    }

    .cls-1521 {
        fill: #f3d3ad
    }

    .cls-1522 {
        fill: #f6dcb8
    }

    .cls-1525 {
        fill: #788e3a
    }

    .cls-1532 {
        fill: #817c76
    }

    .cls-1535 {
        fill: #3d3834
    }

    .cls-1539 {
        fill: #b07b3e
    }

    .cls-1540 {
        fill: #f4c78c
    }

    .cls-1541 {
        fill: #f5d0a0
    }

    .cls-1542 {
        fill: #57514b
    }

    .cls-1543 {
        fill: #f3d3aa
    }

    .cls-1544 {
        fill: #f7ca8e
    }

    .cls-1547 {
        fill: #f2cfa4
    }

    .cls-1555 {
        fill: #493628
    }

    .cls-1556 {
        fill: #b47740
    }

    .cls-1557 {
        fill: #8c5524
    }

    .cls-1559 {
        fill: #d19359
    }

    .cls-1560 {
        fill: #4b3827
    }

    .cls-1561 {
        fill: #825933
    }

    .cls-1562 {
        fill: #5e3e21
    }

    .cls-1563 {
        fill: #d1935a
    }

    .cls-1607 {
        fill: #30251a
    }

    .cls-1608 {
        fill: #7a6852
    }

    .cls-1611 {
        fill: #ed2924
    }

    .cls-1617 {
        fill: #931d1e
    }

    .cls-1681 {
        fill: #5e4b3c
    }

    .cls-1686 {
        fill: #7e694d
    }

    .cls-1687 {
        fill: #a1825c
    }

    .cls-1688 {
        fill: #c39d6e
    }

    .cls-1692 {
        fill: #37281a
    }

    .cls-1693 {
        fill: #232021
    }

    .cls-1701 {
        fill: #526b31
    }

    .cls-1733 {
        fill: #fae059
    }

    .cls-1740 {
        fill: #bc976b
    }

    .cls-1746 {
        fill: #576131
    }

    .cls-1749 {
        fill: #8f9f54
    }

    .cls-1757 {
        fill: #dd922a
    }

    .cls-1758 {
        fill: #7d532c
    }

    .cls-1759 {
        fill: #a36e3f
    }

    .cls-1761 {
        fill: #f5d6aa
    }

    .cls-1762 {
        fill: #4f3a29
    }

    .cls-1764 {
        fill: #f3c68b
    }

    .cls-1767 {
        fill: #f2c58a
    }

    .cls-1768 {
        fill: #f4d3ab
    }

    .cls-1769 {
        fill: #bf8552
    }

    .cls-1771 {
        fill: #a96e30
    }

    .cls-1772 {
        fill: #835c34
    }

    .cls-1773 {
        fill: #ad6728
    }

    .cls-1774 {
        fill: #ac6828
    }

    .cls-1775 {
        fill: #d68f4b
    }

    .cls-1789 {
        fill: #7c5120
    }

    .cls-1791 {
        fill: #beb857
    }

    .cls-1794 {
        fill: #795d25
    }

    .cls-1802 {
        fill: #462c15
    }

    .cls-1803 {
        fill: #85582a
    }

    .cls-1806 {
        fill: #b2793e
    }

    .cls-1823 {
        fill: #9b6c3f
    }

    .cls-1824 {
        fill: #4c392a
    }

    .cls-1831 {
        fill: #a09898
    }

    .cls-1838 {
        fill: #975a25
    }

    .cls-1870 {
        fill: #6f5a40
    }

    .cls-1900 {
        fill: #ed4497
    }

    .cls-1920 {
        fill: #ed4598
    }

    .cls-1930 {
        fill: #826a4a
    }

    .cls-1937 {
        fill: #22b68b
    }

    .cls-1941 {
        fill: #25b68b
    }

    .cls-1945 {
        fill: #df2c26
    }

    .cls-1951 {
        fill: #b72674
    }

    .cls-1954 {
        fill: #d72b27
    }

    .cls-1977 {
        fill: #c8b13b
    }

    .cls-1979 {
        fill: #938330
    }

    .cls-1990 {
        fill: #f05925
    }

    .cls-1992 {
        fill: #9e1d26
    }

    .cls-1993 {
        fill: #7e141f
    }

    .cls-1994 {
        fill: #6c5b4b
    }

    .cls-1995 {
        fill: #31261c
    }

    .cls-1996 {
        fill: #b82f3c
    }

    .cls-1997 {
        fill: #432e1b
    }

    .cls-2001 {
        fill: #5d3c20
    }

    .cls-2011 {
        fill: #1d120d
    }

    .cls-2043 {
        fill: #688b3b
    }

    .cls-2045 {
        fill: #3b2c20
    }

    .cls-2049 {
        fill: #c09a6c
    }

    .cls-2050 {
        fill: #ba966a
    }

    .cls-2051 {
        fill: #7c7b6d
    }

    .cls-2053 {
        fill: #e5e4d1
    }

    .cls-2054 {
        fill: #af282d
    }

    .cls-2056 {
        fill: #b2b1a3
    }

    .cls-2062 {
        fill: #c5c4b2
    }

    .cls-2070 {
        fill: #5c5b4f
    }

    .cls-2091 {
        fill: #f1d8aa
    }

    .cls-2101 {
        fill: #8cd4e4
    }

    .cls-2107 {
        fill: #8bd4e4
    }

    .cls-2125 {
        fill: #71c8d5
    }

    .cls-2172 {
        fill: #a43566
    }

    .cls-2178 {
        fill: #e5e0e0
    }

    .cls-2182 {
        fill: #f05523
    }

    .cls-2196 {
        fill: #84be41
    }

    .cls-2203 {
        fill: #615c45
    }

    .cls-2204 {
        fill: #807a5a
    }

    .cls-2217 {
        fill: #c9972b
    }

    .cls-2219 {
        fill: #e4b43a
    }

    .cls-2220 {
        fill: #e6bf90
    }

    .cls-2221 {
        fill: #d3ab78
    }

    .cls-2223 {
        fill: #e5be8f
    }

    .cls-2239 {
        fill: #f7ddbc
    }

    .cls-2272 {
        fill: #2d9646
    }

    .cls-2275 {
        fill: #62bb4e
    }

    .cls-2278 {
        fill: #86d0d3
    }

    .cls-2279 {
        fill: #7fc146
    }

    .cls-2282 {
        fill: #74953d
    }

    .cls-2284 {
        fill: #f48139
    }

    .cls-2285 {
        fill: #ccdb37
    }

    .cls-2286 {
        fill: #ad5526
    }

    .cls-2288 {
        fill: #b95a27
    }

    .cls-2292 {
        fill: #d96a27
    }

    .cls-2300 {
        fill: #8c441f
    }

    .cls-2302 {
        fill: #c4d82d
    }

    .cls-2304 {
        fill: #a2cc39
    }

    .cls-2318 {
        fill: #88ab3e
    }

    .cls-2320 {
        fill: #9a4a23
    }

    .cls-2325 {
        fill: #a14f24
    }

    .cls-2332 {
        fill: #a24f24
    }

    .cls-2336 {
        fill: #cec8c4
    }

    .cls-2337 {
        fill: #ffefe6
    }

    .cls-2338 {
        fill: #d76327
    }

    .cls-2339 {
        fill: #f4843d
    }

    .cls-2341 {
        fill: #d96627
    }

    .cls-2350 {
        fill: #a04e24
    }

    .cls-2353 {
        fill: #d9e14c
    }

    .cls-2357 {
        fill: #f3d097
    }

    .cls-2358 {
        fill: #607634
    }

    .cls-2359 {
        fill: #aa5f2e
    }

    .cls-2360 {
        fill: #cb743a
    }

    .cls-2362 {
        fill: #70be44
    }

    .cls-2363 {
        fill: #e4eba6
    }

    .cls-2368 {
        fill: #509041
    }

    .cls-2371 {
        fill: #529241
    }

    .cls-2372 {
        fill: #6f973e
    }

    .cls-2374 {
        fill: #b1602f
    }

    .cls-2375 {
        fill: #7a3c1a
    }

    .cls-2376 {
        fill: #e58348
    }

    .cls-2379 {
        fill: #c0d72f
    }

    .cls-2381 {
        fill: #4f7c39
    }

    .cls-2386 {
        fill: #c86f38
    }

    .cls-2389 {
        fill: #6c3717
    }

    .cls-2390 {
        fill: #539542
    }

    .cls-2391 {
        fill: #5c7936
    }

    .cls-2392 {
        fill: #70913c
    }

    .cls-2393 {
        fill: #88aa40
    }

    .cls-2394 {
        fill: #786e61
    }

    .cls-2395 {
        fill: #ecebe6
    }

    .cls-2396 {
        fill: #c5c0b9
    }

    .cls-2397 {
        fill: #226231
    }

    .cls-2398 {
        fill: #38a64e
    }

    .cls-2399 {
        fill: #2e8441
    }

    .cls-2400 {
        fill: #37a14c
    }

    .cls-2401 {
        fill: #a0734e
    }

    .cls-2402 {
        fill: #855e3d
    }

    .cls-2403 {
        fill: #67472f
    }

    .cls-2405 {
        fill: #4c612c
    }

    .cls-2406 {
        fill: #76963d
    }

    .cls-2407 {
        fill: #684930
    }

    .cls-2408 {
        fill: #8f6847
    }

    .cls-2410 {
        fill: #5b2c15
    }

    .cls-2414 {
        fill: #6c963f
    }

    .cls-2415 {
        fill: #813f1c
    }

    .cls-2417 {
        fill: #fffffc
    }

    .cls-2418 {
        fill: #7c5531
    }

    .cls-2419 {
        fill: #c28651
    }

    .cls-2421 {
        fill: #986637
    }

    .cls-2422 {
        fill: #d14727
    }

    .cls-2423 {
        fill: #f4c68c
    }

    .cls-2424 {
        fill: #865f39
    }

    .cls-2425 {
        fill: #5f4124
    }

    .cls-2426 {
        fill: #b57537
    }

    .cls-2427 {
        fill: #ad6928
    }

    .cls-2428 {
        fill: #d28b46
    }

    .cls-2429 {
        fill: #f8ddb9
    }

    .cls-2430 {
        fill: #e0a164
    }

    .cls-2431 {
        fill: #d99857
    }

    .cls-2432 {
        fill: #b37a3e
    }

    .cls-2433 {
        fill: #efc289
    }

    .cls-2434 {
        fill: #8a9589
    }

    .cls-2435 {
        fill: #a73223
    }

    .cls-2437 {
        fill: #c34027
    }

    .cls-2438 {
        fill: #d1cbcb
    }

    .cls-2439 {
        fill: #f7cc96
    }

    .cls-2440 {
        fill: #b8862c
    }

    .cls-2443 {
        fill: #d59929
    }

    .cls-2444 {
        fill: #f8d996
    }

    .cls-2445 {
        fill: #f9db97
    }

    .cls-2446 {
        fill: #b47a3e
    }

    .cls-2447 {
        fill: #d69928
    }

    .cls-2448 {
        fill: #d58c47
    }

    .cls-2449 {
        fill: #d58e49
    }

    .cls-2450 {
        fill: #d9914e
    }

    .cls-2451 {
        fill: #f9ddbb
    }

    .cls-2452 {
        fill: #b4793e
    }

    .cls-2453 {
        fill: #d7904c
    }

    .cls-2454 {
        fill: #b37a3d
    }

    .cls-2458 {
        fill: #f48761
    }

    .cls-2460 {
        fill: #f4d4ab
    }

    .cls-2466 {
        fill: #49797a
    }

    .cls-2469 {
        fill: #8a5524
    }

    .cls-2470 {
        fill: #5f3b1c
    }

    .cls-2471 {
        fill: #4c3019
    }

    .cls-2472 {
        fill: #8b5523
    }

    .cls-2473 {
        fill: #a06c39
    }

    .cls-2497 {
        fill: #6d6868
    }

    .cls-2515 {
        fill: #154a51
    }

    .cls-2578 {
        fill: #104751
    }

    .cls-2581 {
        fill: #f79630
    }

    .cls-2583 {
        fill: #d58e4b
    }

    .cls-2584 {
        fill: #232020
    }

    .cls-2585 {
        fill: #f7d4ab
    }

    .cls-2586 {
        fill: #da904b
    }

    .cls-2587 {
        fill: #fbdfbd
    }

    .cls-2588 {
        fill: #d78f4a
    }

    .cls-2595 {
        fill: #ee4147
    }

    .cls-2600 {
        fill: #32271d
    }

    .cls-2601 {
        fill: #6b594a
    }

    .cls-2603 {
        fill: #caa147
    }

    .cls-2604 {
        fill: #fbe7bb
    }

    .cls-2605 {
        fill: #f6d385
    }

    .cls-2606 {
        fill: #c67429
    }

    .cls-2607 {
        fill: #f5d3ab
    }

    .cls-2608 {
        fill: #dbae4b
    }

    .cls-2609 {
        fill: #b68e36
    }

    .cls-2610 {
        fill: #d38d49
    }

    .cls-2611 {
        fill: #f7dfbc
    }

    .cls-2612 {
        fill: #f2f1f0
    }

    .cls-2613 {
        fill: #f9ddb8
    }

    .cls-2614 {
        fill: #af6928
    }

    .cls-2616 {
        fill: #ae2624
    }

    .cls-2617 {
        fill: #9fae9d
    }

    .cls-2619 {
        fill: #e4ebe2
    }

    .cls-2622 {
        fill: #768376
    }

    .cls-2623 {
        fill: #383a3e
    }

    .cls-2625 {
        fill: #f5d4aa
    }

    .cls-2635 {
        fill: #85cec4
    }

    .cls-2679 {
        fill: #78502c
    }

    .cls-2681 {
        fill: #b02925
    }

    .cls-2682 {
        fill: #cfae64
    }

    .cls-2684 {
        fill: #f7debb
    }

    .cls-2685 {
        fill: #e0a162
    }

    .cls-2687 {
        fill: #f8debe
    }

    .cls-2688 {
        fill: #9eac9d
    }

    .cls-2689 {
        fill: #757e74
    }

    .cls-2695 {
        fill: #626a62
    }

    .cls-2699 {
        fill: #6b4119
    }

    .cls-2701 {
        fill: #ee7123
    }

    .cls-2705 {
        fill: #3f51a0
    }

    .cls-2706 {
        fill: #5bc2b5
    }

    .cls-2713 {
        fill: #b2783e
    }

    .cls-2738 {
        fill: #dc1f2c
    }

    .cls-2739 {
        fill: #412d1b
    }

    .cls-2745 {
        fill: #c47429
    }

    .cls-2748 {
        fill: #f9e0bd
    }

    .cls-2751 {
        fill: #d28d48
    }

    .cls-2752 {
        fill: #f8dcb9
    }

    .cls-2753 {
        fill: #ac6628
    }

    .cls-2754 {
        fill: #b42025
    }

    .cls-2757 {
        fill: #636a62
    }

    .cls-2758 {
        fill: #818287
    }

    .cls-2760 {
        fill: #d3cfd0
    }

    .cls-2762 {
        fill: #4d524d
    }

    .cls-2763 {
        fill: #f4d4ad
    }

    .cls-2766 {
        fill: #62503f
    }

    .cls-2767 {
        fill: #352518
    }

    .cls-2768 {
        fill: #fbdeba
    }

    .cls-2769 {
        fill: #f6cb95
    }

    .cls-2770 {
        fill: #f5d6b1
    }

    .cls-2771 {
        fill: #38281a
    }

    .cls-2774 {
        fill: #ffecc0
    }

    .cls-2777 {
        fill: #ddbb70
    }

    .cls-2789 {
        fill: #fffcf8
    }

    .cls-2793 {
        fill: #ddbb6f
    }

    .cls-2795 {
        fill: #f7c34e
    }

    .cls-2801 {
        fill: #503721
    }

    .cls-2802 {
        fill: #966a42
    }

    .cls-2803 {
        fill: #745131
    }

    .cls-2804 {
        fill: #f5d4ab
    }

    .cls-2805 {
        fill: #d38c45
    }

    .cls-2806 {
        fill: #2b292a
    }

    .cls-2807 {
        fill: #b87d40
    }

    .cls-2808 {
        fill: #d48d47
    }

    .cls-2809 {
        fill: #f6d6ad
    }

    .cls-2810 {
        fill: #b0773c
    }

    .cls-2814 {
        fill: #973720
    }

    .cls-2817 {
        fill: #bb4526
    }

    .cls-2818 {
        fill: #f48159
    }

    .cls-2819 {
        fill: #b37a3f
    }

    .cls-2820 {
        fill: #7a573c
    }

    .cls-2822 {
        fill: #c14b27
    }

    .cls-2825 {
        fill: #f8d5a8
    }

    .cls-2826 {
        fill: #d28b43
    }

    .cls-2827 {
        fill: #f7ddbb
    }

    .cls-2828 {
        fill: #f7deba
    }

    .cls-2829 {
        fill: #d58f4a
    }

    .cls-2831 {
        fill: #ab6628
    }

    .cls-2832 {
        fill: #9c4423
    }

    .cls-2833 {
        fill: #f05722
    }

    .cls-2837 {
        fill: #f69876
    }

    .cls-2840 {
        fill: #5f4f40
    }

    .cls-2841 {
        fill: #c54527
    }

    .cls-2842 {
        fill: #5a391c
    }

    .cls-2843 {
        fill: #fcfdff
    }

    .cls-2844 {
        fill: #e4b172
    }

    .cls-2845 {
        fill: #58371b
    }

    .cls-2846 {
        fill: #5b391c
    }

    .cls-2847 {
        fill: #f5d8b0
    }

    .cls-2848 {
        fill: #d7904d
    }

    .cls-2849 {
        fill: #f6d5ac
    }

    .cls-2850 {
        fill: #b2773c
    }

    .cls-2854 {
        fill: #bb7f42
    }

    .cls-2856 {
        fill: #705948
    }

    .cls-2857 {
        fill: #ffe2be
    }

    .cls-2859 {
        fill: #e09f62
    }

    .cls-2890 {
        fill: #fbdfbb
    }

    .cls-2891 {
        fill: #d89452
    }

    .cls-2892 {
        fill: #d99758
    }

    .cls-2894 {
        fill: #f1c38a
    }

    .cls-2898 {
        fill: #a86928
    }

    .cls-2903 {
        fill: #f9e88a
    }

    .cls-2906 {
        fill: #ba4026
    }

    .cls-2931 {
        fill: #695241
    }

    .cls-2932 {
        fill: #f3f2f0
    }

    .cls-2933 {
        fill: #4a382a
    }

    .cls-2934 {
        fill: #3c2d21
    }

    .cls-2935 {
        fill: #f5d0a5
    }

    .cls-2941 {
        fill: #ae6929
    }

    .cls-2947 {
        fill: #d56292
    }

    .cls-2955 {
        fill: #70675e
    }

    .cls-2961 {
        fill: #493524
    }

    .cls-2964 {
        fill: #453324
    }

    .cls-2965 {
        fill: #7d5f45
    }

    .cls-2966 {
        fill: #6e5643
    }

    .cls-2968 {
        fill: #e8b67b
    }

    .cls-2970 {
        fill: #f9debc
    }

    .cls-2972 {
        fill: #e1a062
    }

    .cls-2976 {
        fill: #f8d6aa
    }

    .cls-2977 {
        fill: #a2913b
    }

    .cls-2981 {
        fill: #66903e
    }

    .cls-3003 {
        fill: #b2793d
    }

    .cls-3012 {
        fill: #4a3525
    }

    .cls-3013 {
        fill: #71553f
    }

    .cls-3034 {
        fill: #6a4e37
    }

    .cls-3035 {
        fill: #9e6934
    }

    .cls-3036 {
        fill: #ae6828
    }

    .cls-3045 {
        fill: #a6703f
    }

    .cls-3047 {
        fill: #d6be40
    }

    .cls-3057 {
        fill: #e83547
    }

    .cls-3061 {
        fill: #0e4751
    }

    .cls-3084 {
        fill: #ae6728
    }

    .cls-3123 {
        fill: #d9914c
    }

    .cls-3124 {
        fill: #d48e4a
    }

    .cls-3125 {
        fill: #f9ddba
    }

    .cls-3126 {
        fill: #f6d7b1
    }

    .cls-3127 {
        fill: #d68f49
    }

    .cls-3143 {
        fill: #b47b3f
    }

    .cls-3173 {
        fill: #10464a
    }

    .cls-3204 {
        fill: #6dcde9
    }

    .cls-3206 {
        fill: #ed3024
    }

    .cls-3216 {
        fill: #b3783b
    }

    .cls-3231 {
        fill: #cb5282
    }

    .cls-3259 {
        fill: #7c4936
    }

    .cls-3260 {
        fill: #3e4d22
    }

    .cls-3261 {
        fill: #7d9f3e
    }

    .cls-3262 {
        fill: #62382a
    }

    .cls-3263 {
        fill: #236734
    }

    .cls-3264 {
        fill: #3eaf56
    }

    .cls-3265 {
        fill: #3fae56
    }

    .cls-3266 {
        fill: #4c2a1e
    }

    .cls-3267 {
        fill: #73973e
    }

    .cls-3268 {
        fill: #b3d241
    }

    .cls-3270 {
        fill: #9d6639
    }

    .cls-3271 {
        fill: #ce864d
    }

    .cls-3317 {
        fill: #165c5c
    }

    .cls-3318 {
        fill: #979090
    }

    .cls-3328 {
        fill: #d6b269
    }

    .cls-3341 {
        fill: #d5b067
    }

    .cls-3343 {
        fill: #d6b168
    }

    .cls-3354 {
        fill: #a9802e
    }

    .cls-3362 {
        fill: #8c6b29
    }

    .cls-3374 {
        fill: #be8a68
    }

    .cls-3381 {
        fill: #9c782c
    }

    .cls-3393 {
        fill: #d52a27
    }

    .cls-3492 {
        fill: #d48d46
    }

    .cls-3493 {
        fill: #d79049
    }

    .cls-3498 {
        fill: #f7d7b1
    }

    .cls-3571 {
        fill: #453528
    }

    .cls-3583 {
        fill: #be2126
    }

    .cls-3609 {
        fill: #c67d2a
    }

    .cls-3611 {
        fill: #986026
    }

    .cls-3619 {
        fill: #b47a3f
    }

    .cls-3627 {
        fill: #c1933e
    }

    .cls-3630 {
        fill: #7a874a
    }

    .cls-3632 {
        fill: #93a64f
    }

    .cls-3633 {
        fill: #faf28f
    }

    .cls-3645 {
        fill: #ae7741
    }

    .cls-3646 {
        fill: #5d3e21
    }

    .cls-3647 {
        fill: #c98d56
    }

    .cls-3655 {
        fill: #4c4b54
    }

    .cls-3692 {
        fill: #b6884b
    }

    .cls-3745 {
        fill: #d6c99a
    }

    .cls-3753 {
        fill: #c62127
    }

    .cls-3756 {
        fill: #fdd608
    }

    .cls-3757 {
        fill: #ed222a
    }

    .cls-3761 {
        fill: #f68e1e
    }

    .cls-3769 {
        fill: #1c8ea7
    }

    .cls-3770 {
        fill: #9c1d20
    }

    .cls-3786 {
        fill: #5b4839
    }

    .cls-3800 {
        fill: #f5531a
    }

    .cls-3805 {
        fill: #372819
    }

    .cls-3807 {
        fill: #fffffe
    }

    .cls-3839 {
        fill: #ec2024
    }

    .cls-3840 {
        fill: #fff7f5
    }

    .cls-3864 {
        fill: #ec2224
    }

    .cls-3885 {
        fill: #d0a2ca
    }

    .cls-3949 {
        fill: #473728
    }

    .cls-4053 {
        fill: #d5914b
    }

    .cls-4083 {
        fill: #9b6b3f
    }

    .cls-4084 {
        fill: #9a6b3f
    }

    .cls-4089 {
        fill: #b9e2e4
    }

    .cls-4090 {
        fill: #9bcc61
    }

    .cls-4118 {
        fill: #658038
    }

    .cls-4119 {
        fill: #9ec63b
    }

    .cls-4120 {
        fill: #6b4b33
    }

    .cls-4122 {
        fill: #115b5c
    }

    .cls-4139 {
        fill: #d2edf7
    }

    .cls-4265 {
        fill: #e93558
    }

    .cls-4275 {
        fill: #1c1b1b
    }

    .cls-4283 {
        fill: #040404
    }

    .cls-4311 {
        fill: #523719
    }

    .cls-4329 {
        fill: #938577
    }

    .cls-4335 {
        fill: #998d80
    }

    .cls-4362 {
        fill: #ec5627
    }

    .cls-4414 {
        fill: #574f46
    }

    .cls-4439 {
        fill: #a2978b
    }

    .cls-4458 {
        fill: #c48033
    }

    .cls-4488 {
        fill: #c48034
    }

    .cls-4615 {
        fill: #ef5555
    }

    .cls-4696 {
        fill: #ba9648
    }

    .cls-4771 {
        fill: #d68f4a
    }

    .cls-4796 {
        fill: #569442
    }

    .cls-4847 {
        fill: #e5b272
    }

    .cls-4946 {
        fill: #b7c589
    }

    .cls-4976 {
        fill: #db973e
    }

    .cls-4982 {
        fill: #abbb6e
    }

    .cls-4999 {
        fill: #a0b16a
    }

    .cls-5012 {
        fill: #dcf0f1
    }

    .cls-5013 {
        fill: #8b3212
    }

    .cls-5020 {
        fill: #43372d
    }

    .cls-5021 {
        fill: #f5c78d
    }

    .cls-5023 {
        fill: #ffe3bf
    }

    .cls-5024 {
        fill: #473729
    }

    .cls-5025 {
        fill: #ad6626
    }

    .cls-5026 {
        fill: #8c5523
    }

    .cls-5027 {
        fill: #58371a
    }

    .cls-5028 {
        fill: #5b391b
    }

    .cls-5029 {
        fill: #d58e48
    }

    .cls-5030 {
        fill: #f98014
    }

    .cls-5031 {
        fill: #fefdfc
    }

    .cls-5032 {
        fill: #d8924e
    }

    .cls-5033 {
        fill: #d6904c
    }

    .cls-5034 {
        fill: #f7d7ad
    }

    .cls-5035 {
        fill: #af6827
    }

    .cls-5036 {
        fill: #fadeba
    }

    .cls-5037 {
        fill: #b3773d
    }

    .cls-5038 {
        fill: #f7d7ae
    }

    .cls-5040 {
        fill: #875610
    }

    .cls-5041 {
        fill: #b47419
    }

    .cls-5044 {
        fill: #d28a23
    }

    .cls-5055 {
        fill: #7a5014
    }

    .cls-5056 {
        fill: #d08b2a
    }

    .cls-5060 {
        fill: #6c5a4a
    }

    .cls-5061 {
        fill: #705947
    }

    .cls-5174 {
        fill: #b57a3f
    }

    .cls-5177 {
        fill: #da914c
    }

    .cls-5180 {
        fill: #fce1be
    }

    .cls-5182 {
        fill: #b4793f
    }

    .cls-5183 {
        fill: #d38e49
    }

    .cls-5184 {
        fill: #ad6627
    }

    .cls-5185 {
        fill: #fbe1be
    }

    .cls-5206 {
        fill: #58402c
    }

    .cls-5211 {
        fill: #dd182b
    }

    .cls-5213 {
        fill: #1dc8c2
    }

    .cls-5218 {
        fill: #5f4024
    }

    .cls-5225 {
        fill: #b67538
    }

    .cls-5231 {
        fill: #fadfba
    }

    .cls-5232 {
        fill: #f7d6ac
    }

    .cls-5233 {
        fill: #da9957
    }

    .cls-5234 {
        fill: #143384
    }

    .cls-5285 {
        fill: #ae8212
    }

    .cls-5310 {
        fill: #b31626
    }

    .cls-5311 {
        fill: #f35b69
    }
</style>
